export default function setSelectedBranch(branch) {
  return (notify, getSceneState) => {
    const state = getSceneState();

    state.selectedBranch = branch;

    notify();
  };
}
